// FE-SCRM-048 — Type contracts for the CSV import pipeline.
//
// Mirrors the BE-SCRM-047 serializer at backend/sales/import_views.py
// and the ValidationReport / CommitSummary shapes in csv_imports.py.
// The validator emits `errors`/`warnings` as `{row, field, message}`
// records with row 1 = header, row 2 = first data row.

export type ImportType = "prospects" | "sales_contacts";

export type ImportStatus =
  | "validating"
  | "validated"
  | "committing"
  | "completed"
  | "failed"
  | "expired";


export interface ValidationIssue {
  row: number;
  field: string;
  message: string;
}


export interface ValidationReport {
  valid_count: number;
  error_count: number;
  warning_count: number;
  errors: ValidationIssue[];
  warnings: ValidationIssue[];
}


export interface CommitSummary {
  prospects_created?: number;
  form5500_matches_queued?: number;
  contacts_created?: number;
  error?: string;
}


export interface ImportSession {
  session_id: string;
  import_type: ImportType;
  status: ImportStatus;
  file_id: string | null;
  filename: string | null;
  validation_report: ValidationReport | null;
  commit_summary: CommitSummary | null;
  created_at: string | null;
  expires_at: string | null;
  completed_at: string | null;
  created_by_id: string | null;
}


export interface ImportListResponse {
  rows: ImportSession[];
  total: number;
}


export const IMPORT_TYPE_LABEL: Record<ImportType, string> = {
  prospects: "Prospects",
  sales_contacts: "Sales contacts",
};
